
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.87 11.87a.842.842 0 011.192 0l.595.596a.842.842 0 01-1.191 1.19l-.596-.594a.842.842 0 010-1.192zM2.343 2.343a.842.842 0 011.191 0l.596.595A.842.842 0 112.938 4.13l-.595-.596a.842.842 0 010-1.19zM8 12.21a4.21 4.21 0 110-8.42 4.21 4.21 0 010 8.42zm0 1.264a.843.843 0 01.842.842v.842a.842.842 0 01-1.684 0v-.842A.843.843 0 018 13.474zM8 0c.465 0 .842.377.842.842v.838a.842.842 0 01-1.684 0V.838A.842.842 0 018 0zm5.474 8c0-.465.377-.842.842-.842h.842a.842.842 0 010 1.684h-.842A.842.842 0 0113.474 8zM0 8c0-.465.377-.842.842-.842h.842a.842.842 0 110 1.684H.842A.842.842 0 010 8zm11.87-3.87a.842.842 0 010-1.192l.596-.595a.842.842 0 011.19 1.191l-.594.596a.842.842 0 01-1.192 0zm-9.527 9.527a.842.842 0 010-1.191l.595-.596a.842.842 0 011.192 1.192l-.596.595a.842.842 0 01-1.19 0z"}})])
          )
        }
      }
    